import { render, staticRenderFns } from "./Potree.vue?vue&type=template&id=f1d6e15a&"
import script from "./Potree.vue?vue&type=script&lang=js&"
export * from "./Potree.vue?vue&type=script&lang=js&"
import style0 from "./Potree.vue?vue&type=style&index=0&id=f1d6e15a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports